<template>
  <div class="m-content">
    <div class="c-content">
      <div class="card1 flex-center-between">
        <div>
          <span>{{ count }}</span>
          <span>/{{ tmzs }}</span>
        </div>
        <div class="font-17">答题倒计时：{{ msg }}</div>
      </div>
      <div v-show="activeIndex == 1" class="card card-columns" style="flex: 1">
        <div class="dx-title">单选题</div>
        <div class="scroll-view"  >
          <div style="margin-bottom: 20px; padding: 0 12px" v-for="(item, index) in danList" :key="index">
            <div class="tmmc">{{ index + 1 }}、{{ item.tmmc }}</div>
            <div class="tmx-item">
              <van-radio-group v-model="item.dtxxId" width="100%" @change="changeAllChecked">
                <van-radio
                  class="tmx"
                  :customStyle="{ marginBottom: '8px' }"
                  v-for="(obj, i) in item.tmxxList"
                  :key="i"
                  :name="obj.id"
                >
                  {{ indexList[i] }}、{{ obj.xxmc }}
                </van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div class="t-bottom">
          <button class="mbtn" @click="clickNext()">下一页</button>
        </div>
      </div>
      <div v-show="activeIndex == 2" class="card card-columns" style="flex: 1">
        <div class="dx-title">多选题</div>

        <div class="scroll-view">
          <div style="margin-bottom: 20px; padding: 0 12px" v-for="(item, index) in duoList" :key="index">
            <div class="tmmc">{{ index + 1 }}、{{ item.tmmc }}</div>
            <div class="tmx-item">
              <van-checkbox-group v-model="item.dtxxId" width="100%" @change="checkboxGroupChange">
                <van-checkbox
                  class="tmx"
                  :customStyle="{ marginBottom: '8px' }"
                  v-for="(obj, i) in item.tmxxList"
                  v-model="obj.checked"
                  :key="i"
                  :name="obj.id"
                >
                  {{ indexList[i] }}、{{ obj.xxmc }}
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
        </div>
        <div class="t-bottom" style="display: flex; justify-content: space-between">
          <button class="mbtn" style="width: 40%" @click="clickpre()">上一页</button>
          <button class="mbtn" style="width: 40%" @click="clickSumbit()">提交</button>
        </div>
      </div>
    </div>

<van-popup border-radius="10" v-model="showJg"
    	 mode="center" 
    	:closeable="false"
      :mask-close-able="false"
      position="center" :style="{ width: '70%','border-radius':'10px' }"
    >
    	<div  class="pop-p" >
    	   <img src="@images/zhdj/success.png" class="pop-image" mode="widthFix"/>
    		 <span class="desc">完成答题</span>
         <span class="fs">{{dtfs}}分</span>
          <button class="mbtn" style="width: 90%;" @click="clickClose()">关闭</button> 
    	</div>
    </van-popup>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { matchType } from '@/utils/util'
export default {
  data() {
    return {
      curTab: 0,
      xm: '',
      id: '',
      object: {},
      activeIndex: 1,
      show: false,
      maxtime: 60,
      msg: '',
      timer: {},
      tmList: [],
      danList: [],
      duoList: [],
      indexList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
      count: 0,
      tmzs: 0,
      kssc: 0,
      model: {},
      index: 0,
      content: '',
      dtjbxxId: '',
      showJg: false,
      dtfs: 0,
    }
  },
  created() {
     
    this.id = this.$route.query.id;
    this.getData()
  },
  onShow() {},
  methods: {
    getData() {
      let params = { kshdId: this.id }

      let url = '/yqfk/kshddtjbxx/add'
        postAction(url, params)
        .then((res) => {
          if (res.success) {
            let obj = res.result
            this.dtjbxxId = obj.dtjbxxId
            this.tmzs = obj.sjxxList.length
            for (let item of obj.sjxxList) {
              if (item.tklx == '01') {
                item.dtxxId = ''
                this.danList.push(item)
              } else if (item.tklx == '02') {
                item.dtxxId = []
                this.duoList.push(item)
              }
            }
          }
        })
        .catch((error) => {})
    },
    clickNext() {
      this.activeIndex = 2
      // this.toTop()
    },
    clickpre() {
      this.activeIndex = 1

      this.toTop()
    },
    clickRadio(index, obj) {
      this.danList[index]['dtxxId'] = obj.id
    },
    toTop() {
      // uni.pageScrollTo({
      //   top: 0,
      // })
    },
    changeAllChecked() {
      let count = 0
      for (let item of this.danList) {
        if (item.dtxxId != '') {
          count++
        }
      }
      console.log(this.danList)
      console.log(this.duoList)
      for (let item of this.duoList) {
        if (item.dtxxId.length > 0) {
          count++
        }
      }
      this.count = count
    },
    checkboxGroupChange(e) {
      // this.duoList[this.index]['dtxxId'] = e
      this.changeAllChecked()
    },
    checkboxChange(e) {
      this.index = e
    },
    sumbitData() {
      let url = '/yqfk/kshddtjbxx/tjdt'
      let arr = []
      for (let item of this.duoList) {
        let obj = Object.assign({}, item)
        obj.dtxxId = item.dtxxId.join(',')
        arr.push(obj)
      }
      this.model.sjxxList = [...this.danList, ...arr]
      this.model.dtjbxxId = this.dtjbxxId
        postAction(url, this.model)
        .then((res) => {
          if (res.success) {
            this.dtfs = res.result.dtfs
            this.showJg = true
          }
        })
        .catch((error) => {
        })
    },
    clickSumbit() {
      console.log(this.duoList);
      if (this.tmzs > this.count) {
        let wdts = this.tmzs - this.count
        let content = `您还有${wdts}题未答，请继续答题`
        this.showDialog(content);
      } else {
        this.sumbitData()
      }
    },
    showDialog(content) {
      this.$dialog
        .alert({
          title: '提示',
          message: content,
          confirmButtonText: '确定',
          confirmButtonColor: '#3f8ffb',
        })
        .then(() => {
         
        })
    },
    clickClose() {
      this.showJg = false
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="less" scoped>
.m-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.c-content {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 11px 16px 11px;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #2680eb 0%, #02b7fe 100%);
}
.card1 {
  height: 43px;
  line-height: 43px;
  background: #fefefe;
  border-radius: 10px;
  padding: 0 20px;
  margin-bottom: 10px;
  /* font-size: 17px; */
}
.font-17 {
  /* font-size: 17px; */
}

.card-columns {
  border-radius: 10px 10px 0px 0px;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: calc(100% - 54px);
  overflow: hidden;
}
.scroll-view{
  height: 60vh;
  overflow-y: scroll;
}
.t-scroll {
  flex: 1;
  padding: 6px 18px;
}
.mbtn {
  height: 35px;
  background: #03b7fe;
  opacity: 1;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  font-size: 15px;
  border: none;
}
.mbtn :active {
  opacity: 0.8;
}
.t-bottom {
  padding: 16px 20px;
}
.dx-title {
  width: 95px;
  height: 32px;
  background: #03b7fe;
  opacity: 1;
  border-radius: 0px 16px 16px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  margin-top: 14px;
  margin-bottom: 10px;
}
.tmmc {
  line-height: 28px;
  color: #000000;
  margin-bottom: 4px;
  font-size: 15px;
}
.tmx-item {
  border: 1px solid #d8d8d8;
}
.tmx-item .tmx {
  border-bottom: 1px solid #d8d8d8;
  padding: 10px 10px 10px 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.tmx-item :last-child {
  border-bottom: none;
}
.tmxx {
  color: #504f4f;
  font-size: 14px;
  margin-left: 8px;
}
.line-row {
  width: 100%;
  height: 1px;
  background: #d1d1d1;
  margin-top: 10px;
  margin-bottom: 10px;
}
.mbtn1 {
  height: 35px;
  background: #339afe;
  opacity: 1;
  border-radius: 18px;
  color: #ffffff;
  padding: 0 18px;
}
.card {
  width: 100%;
  background: #fefefe;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  margin-bottom: 10px;
}

.pop-p {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  .pop-image {
    width: 65%;
  }

  .desc {
    font-size: 18px;
    margin: 10px 0;
  }
  .fs {
    font-size: 25px;
    color: #03b7fe;
    margin-bottom: 10px;
  }
}
</style>
